import { Roles } from '../../enums';

export interface IUser {
    gid: string;
    roles: Roles[];
    firstName: string;
    lastName: string;
    email: string;
    phoneNumber: string;
    createdAt: Date;
    updatedAt: Date;
    country: string;
    manager?: IUser;
}

export interface ICreateUser {
    gid: string;
    roles: Roles[];
    firstName: string;
    lastName: string;
    email: string;
    country: string;
    managerGid?: string;
}

export interface IPatchUser {
    roles?: Roles[];
    firstName?: string;
    lastName?: string;
    email?: string;
    country?: string;
    managerGid?: string;
}

export interface IEntraIdUser {
    gid: string;
    firstName: string;
    surName: string;
    mail: string;
    country: string;
    gidManager: string;
    department: string;
}
